import React from 'react';
import ReactCodeInput from 'react-verification-code-input';

import { Record } from '../../modules/bin/utility';

import config from '../../constants';
import { verificationVariant } from '../../constants/multiFactorAuth';
import { I18n } from 'react-redux-i18n';

class VerificationForm extends React.Component {
  constructor(props) {
    super(props);

    this.reactCodeInputRef = React.createRef();
  }

  componentDidUpdate = (prevProps) => {
    this.handleSecurityApprovalError(prevProps);
  };

  clearVerificationCode = () => {
    this.props.handleValueChange(`${this.props.path}.authCode`, null);
    this.reactCodeInputRef.current.__clearvalues__();
  };

  handleSecurityApprovalError = (prevProps) => {
    if (this.props.verificationRecord) {
      const isPrevRecordError = Record.isError(prevProps.verificationRecord);
      const isCurrentRecordError = Record.isError(
        this.props.verificationRecord
      );

      if (isCurrentRecordError && isPrevRecordError !== isCurrentRecordError) {
        this.clearVerificationCode();
      }
    }
  };

  handleValueChange = (value) => {
    this.props.handleValueChange(`${this.props.path}.authCode`, value);
  };

  handleVerificationVariantChange = () => {
    this.props.handleVerificationVariantChange(
      verificationVariant.recoveryCode
    );
    this.props.handleValueChange(`${this.props.path}.authCode`, null);
  };

  render() {
    return (
      <div className="verification-container">
        <ReactCodeInput
          className="verification-input"
          title={I18n.t('authentication.mfa.codeTitle')}
          autoFocus
          fields={config.VERIFICATION_CODE_LENGTH}
          fieldWidth={54}
          onChange={this.handleValueChange}
          ref={this.reactCodeInputRef}
        />
        <p className="alternative-variant">
          <p
            className="Links"
            onClick={this.handleVerificationVariantChange}
            style={{ marginLeft: "4px", }}
          >
            {I18n.t('authentication.mfa.useRecoveryCode')}
          </p>
        </p>
      </div>
    );
  }
}

export default VerificationForm;
